import { getUnitName } from "./loadTypeUtils";

export const APP_VERSION = "v1.5.41";

export const APP_UPDATE_DELAY = 1 * 60_000; // 1 min
export const APP_UPDATE_DELAY_TEXT = "one minute";
export const APP_UPDATE_POLL_INTERVAL = 15 * 60_000; // 15 minutes

export const CLOUD_FRONT_URL = "https://d39ca6oe017qum.cloudfront.net";
export const ZAPIER_CLIENT_ID = "2VZZG8GDnAX2InHg9yPcduBfUz1zQSACiGdktZrm";

export const CARLOT_PO_NO_CHARS = 3;
export const ERROR_MSG =
  "An error occured, please contact us at 1-877-TRANSLOAD";
export const HIDE_FEATURE_BADGES = false;
export const MAX_FILE_SIZE = 10000000; // 10,000,000 bytes decimal = 10,485,760 bytes binary
export const MAX_FILE_SIZE_MSG = "File too large. Max file size is 10 Mb.";
export const MAX_FILES = 10;
export const MAX_FILEs_MSG = `Max. ${MAX_FILES} attachments per record.`;
export const ACCEPTED_FILES = "image/*,.pdf,.doc,.docx,.xls,.xlsx,.csv,.txt";
// Inbound advice attachments: PNG, JPEG, TIFF, PDF only (not all images).
export const ACCEPTED_FILES_ADVICE =
  "image/png,image/jpeg,image/jpg,image/pjpeg,image/tiff,application/pdf,.png,.jpg,.jpeg,.jfif,.tif,.tiff,.pdf";
export const MAX_PHOTO_SIZE = 12000000; // 12,000,000 bytes decimal = 12,582,912 bytes binary
export const MAX_PHOTO_SIZE_MSG =
  "Photo too large. Max image size is 12 Mb or 24 MP JPEG";
export const MAX_PHOTO_NUM_INBOUND = 25;
export const MAX_PHOTO_NUM_OUTBOUND = 25;
export const MAX_PHOTO_NUM_INVENTORY = 12;
export const MAX_ROWS_UPLOAD = 500; // catalog upload limit
export const VALIDATION_MSG = "ra.message.invalid_form"; // "The form is not valid. Please check for errors.";
export const RA_REQUIRED = "ra.validation.required";
export const SORTKEY_BUFFER = 10001; // required for key queries where sortKey is in a coumpound key (treated as string)
export const MAX_INVENTORY_QUERY_LIMIT = 250; // 1MB internal query limit breaking dataProvider result count. Use when comparing (response.total > runningTotal)
export const MAX_INVOICE_LINE_ITEMS = 200; // per generated invoice; QBO caps taxable invoices at 750 lines, invoice queries read up to 1000

export const KB_CHAT_DRAWER_WIDTH_PX = 360;
export const KB_CHAT_EXTRA_OFFSET_PX = 25;
export const KB_CHAT_PUSH_PX =
  KB_CHAT_DRAWER_WIDTH_PX + KB_CHAT_EXTRA_OFFSET_PX;

export const REGEX_MULTI_EMAIL =
  /^\s*((([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))(\s*(;|,)\s*|\s*$))*$/;
export const REGEX_URL =
  /^(https?:\/\/)?(www\.)?[a-zA-Z0-9]+([-.][a-zA-Z0-9]+)*\.[a-zA-Z]{2,5}(:[0-9]{1,6})?(\/.*)?$/;
export const REGEX_PHONE = /^(\(?\+?[0-9]*\)?)?[0-9_\- ()]*$/;

export const JS_PREFIX_REGEX = /^\s*js:\s*/i;
export const SUPPORTED_JS_ACTIONS = {
  produktlyChangelog: {
    regex:
      /^window\.Produktly\.openChangelog\(\s*\{\s*id\s*:\s*(\d+)\s*\}\s*\)\s*;?\s*$/,
    toArgs: (match) => ({ id: Number(match[1]) }),
    handler: ({ id }) => window?.Produktly?.openChangelog?.({ id }),
  },
};

export const AccountType = {
  CUSTOMER: "CUSTOMER",
  INTERNAL: "INTERNAL",
  BROKERED: "BROKERED",
};

export const AccountTypeChoices = [
  { id: AccountType.CUSTOMER, name: "Customer" },
  { id: AccountType.INTERNAL, name: "Internal" },
  { id: AccountType.BROKERED, name: "Brokered" },
];

export const AclType = {
  ACCOUNTS: "ACCOUNTS",
  ASSIGN_LOCATION: "ASSIGN_LOCATION",
  GATE_MANAGEMENT: "GATE_MANAGEMENT",
  INBOUND_ADVICE: "INBOUND_ADVICE",
  INVOICES: "INVOICES",
  INVOICES_VIEW: "INVOICES_VIEW",
  MY_YARD: "MY_YARD",
  OUTBOUND_ADVICE: "OUTBOUND_ADVICE",
  OUTBOUND_VERIFY: "OUTBOUND_VERIFY",
  OUTBOUND_SIGN: "OUTBOUND_SIGN",
  SIT: "SIT",
  TRACK_MANAGEMENT: "TRACK_MANAGEMENT",
  USERS: "USERS",
  CLAIM_LOAD: "CLAIM_LOAD",
};

export const ActiveTrueOrFalse = [
  { id: "true", name: "Yes" },
  { id: "false", name: "No" },
];

export const AppType = {
  ADMIN: "ADMIN",
  CARRIER: "CARRIER",
  CUSTOMER: "CUSTOMER",
  DRIVER: "DRIVER",
  REGISTRATION: "REGISTRATION",
  YARD: "YARD",
};

export const ARRCarTypeChoices = [
  { id: "A", name: "Equipped box car" },
  { id: "B", name: "Unequipped box car" },
  { id: "C", name: "Covered hopper car" },
  { id: "D", name: "Locomotive" },
  { id: "E", name: "Equipped gondola car" },
  { id: "F", name: "Flatcar" },
  { id: "G", name: "Unequipped gondola car" },
  { id: "H", name: "Unequipped hopper car" },
  { id: "J", name: "Gondola car" },
  { id: "K", name: "Equipped hopper car" },
  { id: "L", name: "Special type car" },
  { id: "M", name: "Maintenance or service car (MOW)" },
  { id: "P", name: "Conventional intermodal car" },
  { id: "Q", name: "Low-profile intermodal car" },
  { id: "R", name: "Refrigerator (reefer) car" },
  { id: "S", name: "Stack car" },
  { id: "T", name: "Tank car" },
  { id: "U", name: "Container" },
  { id: "V", name: "Vehicular flatcar" },
  { id: "Z", name: "Trailer (TOFC/COFC service)" },
];

export const AreaType = {
  YARD: "YARD",
  WAREHOUSE: "WAREHOUSE",
  TRACK: "TRACK",
  BULK: "BULK",
};

export const AreaTypeOptions = [
  { id: "YARD", name: " Open Air Lot" },
  { id: "WAREHOUSE", name: "Covered / Warehouse" },
  { id: "BULK", name: "Bulk Storage" },
  { id: "TRACK", name: "Rail Track" },
];

export const DefaultAreas = [
  {
    id: "YARD",
    name: "Yard",
    prefix: "Y",
    color: "#81C784",
    areaType: AreaType.YARD,
  },
  {
    id: "WAREHOUSE",
    name: "Warehouse",
    prefix: "W",
    color: "#FFB74D",
    areaType: AreaType.WAREHOUSE,
  },
  {
    id: "TRACK",
    name: "Track",
    prefix: "T",
    color: "#4DD0E1",
    areaType: AreaType.TRACK,
  },
];

export const AuditStatus = {
  NEW: "NEW",
  IN_PROGRESS: "IN_PROGRESS",
  PENDING_REVIEW: "PENDING_REVIEW",
  COMPLETED: "COMPLETED",
};

export const AuditStatuses = [
  { id: "NEW", name: "New" },
  { id: "IN_PROGRESS", name: "In Progress" },
  { id: "COMPLETED", name: "Completed" },
  { id: "PENDING_REVIEW", name: "Pending Review" },
];

export const CalendarLayout = {
  TODAY_VIEW: "TODAY_VIEW",
  WEEK_VIEW: "WEEK_VIEW",
};

export const CarrierType = {
  RAIL: "RAIL",
  TRUCK: "TRUCK",
};

export const CarrierTypes = [
  { id: CarrierType.RAIL, name: "Rail" },
  { id: CarrierType.TRUCK, name: "Truck" },
];

export const colorsDark = [
  "#F44336",
  "#E91E63",
  "#9C27B0",
  "#673AB7",
  "#3F51B5",
  "#2196F3",
  "#03A9F4",
  "#00BCD4",
  "#009688",
  "#4CAF50",
  "#8BC34A",
  "#CDDC39",
  "#FFC107",
  "#FF9800",
  "#FF5722",
  "#795548",
  "#607D8B",
  "#969696",
];

export const colorsLight = [
  "#FFCDD2",
  "#F8BBD0",
  "#E1BEE7",
  "#D1C4E9",
  "#C5CAE9",
  "#BBDEFB",
  "#B3E5FC",
  "#B2EBF2",
  "#B2DFDB",
  "#C8E6C9",
  "#DCEDC8",
  "#F0F4C3",
  "#FFF9C4",
  "#FFECB3",
  "#FFE0B2",
  "#FFCCBC",
  "#D7CCC8",
  "#CFD8DC",
];

export const CountryList = [
  { id: "USA", name: "USA" },
  { id: "CA", name: "Canada" },
  { id: "MX", name: "Mexico" },
];

export const CustomFieldsDisplay = {
  MOBILE: "MOBILE",
  POD: "POD",
  POS: "POS",
  TALLYSHEET: "TALLYSHEET",
};

export const CustomFieldsDisplayOptions = [
  { id: CustomFieldsDisplay.MOBILE, name: "Mobile" },
  { id: CustomFieldsDisplay.TALLYSHEET, name: "Tally Sheet" },
  { id: CustomFieldsDisplay.POD, name: "POD" },
  { id: CustomFieldsDisplay.POS, name: "POS" },
];

export const DefaultTaxRates = [
  { taxCode: "Exempt", name: "Exempt", taxRate: 0 },
];

export const AstTaxCode = {
  EXCEMPT: "NON",
  TAXABLE: "TAX",
};

export const DefaultTaxRatesAST = [
  { taxCode: AstTaxCode.EXCEMPT, name: "Exempt", taxRate: 0 },
  { taxCode: AstTaxCode.TAXABLE, name: "Taxable", taxRate: 0 },
];

export const ExternalStatus = {
  SYNC_PENDING: "SYNC_PENDING",
  SYNC_FAILED: "SYNC_FAILED",
  SYNCED: "SYNCED",
};

export const FileVisibilityOptions = [
  { id: 101, name: "All" },
  { id: 201, name: "Manager" },
];

export const FilePaths = {
  ACCOUNT: "account",
  DOCUMENTS: "documents",
  KB_FILES: "kbFiles",
  KB_MEDIA: "kbMedia",
  KB_HELP_PAGES: "kbHelpPages",
  INBOUND: "inbound",
  INVENTORY: "inventory",
  OUTBOUND: "outbound",
  INVOICE: "invoice",
  RELOADYARD: "reloadYard",
  TASKS: "task",
  CARRIER_USER: "carrierUser",
  TEMPLATES: "docxTemplates", // system-wide templates, specified below
  TEMPLATES_PDF: "pdfTemplates", // system-wide templates, specified below
  TEMPLATE_BOL: "Bill_Of_Lading_Template.docx",
  TEMPLATE_RECEIPT: "Inbound_Receipt_Template.docx",
  TEMPLATE_INBOUND: "inbound_daily_template.ejs",
  TEMPLATE_OUTBOUND: "outbound_daily_template.ejs",
  TEMPLATE_INVENTORY: "inventory_daily_template.ejs",
  TEMPLATE_REPORT: "reports.ejs",
  TRANSLOADS_LOGO: "powered_by_transloads_logo.png",
};

/**
 * A driver's progress through the gate, from the kiosk check-in to the truck
 * leaving. Written by the driver API and by both Gate Queue pages, and read by
 * the queue ordering, the shipment dispatch tabs and the driver's own phone —
 * every one of which used to spell the values out locally.
 *
 * ARRIVED → CALLED → DOCKED → DEPARTED is the ordinary run; CANCELLED ends
 * a visit from any of them. The driver PWA keeps its own copies: it is a
 * separate public bundle, and this module reaches AppSync through
 * loadTypeUtils.
 */
export const GateCheckInStatus = {
  ARRIVED: "ARRIVED",
  CALLED: "CALLED",
  DOCKED: "DOCKED",
  DEPARTED: "DEPARTED",
  CANCELLED: "CANCELLED",
};

export const InboundState = {
  NEW: "NEW",
  PROCESS_SHIPMENT: "PROCESS_SHIPMENT",
  APPROVE_SHIPMENT: "APPROVE_SHIPMENT",
  PROCESS_INVENTORY: "PROCESS_INVENTORY",
  APPROVE_INVENTORY: "APPROVE_INVENTORY",
  PROCESS_INVENTORY_REVIEW: "PROCESS_INVENTORY_REVIEW",
  APPROVE_INVENTORY_REVIEW: "APPROVE_INVENTORY_REVIEW",
  COMPLETED: "COMPLETED",
  REJECTED: "REJECTED",
};

export const InboundSteps = [
  "Accept Shipment",
  "Process Inventory",
  "Review Inventory",
];
export const InboundTrackSteps = ["Spot Railcar", ...InboundSteps];
export const InboundStepsChoices = [
  // { id: 'Spot Railcar', name: 'Spot Railcar' },
  { id: "Accept Shipment", name: "Accept Shipment" },
  { id: "Process Inventory", name: "Process Inventory" },
  { id: "Review Inventory", name: "Review Inventory" },
];

export const processNames = [
  { id: "Inbound Shipment", name: "Inbound Shipment" },
  // { id: 'Outbound Shipment', name: 'Outbound Shipment' },
];

export const InboundStates = [
  { id: InboundState.NEW, name: "" },
  { id: InboundState.PROCESS_SHIPMENT, name: "Inspect Shipment" },
  { id: InboundState.APPROVE_SHIPMENT, name: "Approve Shipment" },
  { id: InboundState.PROCESS_INVENTORY, name: "Accepted" },
  { id: InboundState.APPROVE_INVENTORY, name: "Approve Inventory" },
  { id: InboundState.PROCESS_INVENTORY_REVIEW, name: "Review Inventory" },
  { id: InboundState.COMPLETED, name: "Completed" },
  { id: InboundState.REJECTED, name: "Rejected" },
];

export const InboundStatus = {
  NEW: "NEW",
  ADVICE_ALL: "ADVICE_",
  ADVICE_PROCESSING: "ADVICE_PROCESSING",
  ADVICE_REVIEW: "ADVICE_REVIEW",
  ADVICE_REJECTED: "ADVICE_REJECTED",
  ADVICE_FAILED: "ADVICE_FAILED",
  IN_TRANSIT: "IN_TRANSIT",
  SIT_PENDING: "SIT_PENDING",
  ARRIVED: "ARRIVED",
  PLACED: "PLACED",
  SIT_PLACED: "SIT_PLACED",
  AGGREGATED: "AGGREGATED",
  RELEASED: "RELEASED",
  ARCHIVED: "ARCHIVED", // Aggregate bulk inbound dissociated from location
};

export const InboundStatuses = [
  { id: "NEW", name: "New, Unsaved" },
  { id: "ADVICE_PROCESSING", name: "Advice Processing" },
  { id: "ADVICE_REVIEW", name: "Advice Review" },
  { id: "ADVICE_REJECTED", name: "Advice Rejected" },
  { id: "ADVICE_FAILED", name: "Advice Failed" },

  { id: "IN_TRANSIT", name: "In Transit" },
  { id: "SIT_PENDING", name: "Pending" },
  { id: "ARRIVED", name: "Arrived" },
  { id: "PLACED", name: "Placed" },
  { id: "SIT_PLACED", name: "Placed" },
  { id: "RELEASED", name: "Released" },
];

export const InboundSubjectTokens = [
  { key: "{poNumber}", label: "Order Number" },
  { key: "{railCarNumber}", label: "Car/Trl Number" },
  { key: "{reloadYard.name}", label: "Yard Name" },
];

export const PODDefaultSubject = [
  { type: "text", value: "Order #:" },
  { type: "token", value: "{poNumber}" },
  { type: "text", value: "received at" },
  { type: "token", value: "{reloadYard.name}" },
];
export const WorkOrderState = {
  READY: "READY",
  IN_PROGRESS: "IN_PROGRESS",
  PENDING_REVIEW: "PENDING_REVIEW",
  COMPLETED: "COMPLETED",
  CANCELLED: "CANCELLED",
};

export const WorkOrderSteps = ["Start Work", "Process Items", "Review Output"];

export const InventoryStatus = {
  NEW: "NEW",
  ADVICE_REVIEW: "ADVICE_REVIEW",
  IN_TRANSIT: "IN_TRANSIT",
  ARRIVED: "ARRIVED",
  UNLOADED: "UNLOADED", // to prevent committing to outbound before inbound RELEASE
  REVIEW: "REVIEW",
  STORED: "STORED",
  AGGREGATED: "AGGREGATED", // bulk inventory aggregated to a single location
  LOADED: "LOADED", // NOT IN USE
  SHIPPED: "SHIPPED",
  RELEASED: "RELEASED", // SIT inventory released
  ARCHIVED: "ARCHIVED", // Aggregate bulk inventory dissociated from location
};

export const InventoryStatuses = [
  { id: "NEW", name: "New, Unsaved" },
  { id: "IN_TRANSIT", name: "In Transit" },
  { id: "ARRIVED", name: "Placed" },
  { id: "UNLOADED", name: "Unloaded" },
  { id: "REVIEW", name: "In Review" },
  { id: "STORED", name: "Stored" },
  { id: "AGGREGATED", name: "Stored Aggregated" },
  { id: "SHIPPED", name: "Depleted" },
  { id: "RELEASED", name: "Released" },
];

export const originDamageList = [
  { id: "yard", name: "Yard" },
  { id: "carrier", name: "Carrier" },
  { id: "other", name: "Other" },
];

export const InvoicingMode = {
  BULK: "BULK",
  PER_SHIPMENT: "PER_SHIPMENT",
};

export const InvoiceStatus = {
  NEW: "NEW",
  PENDING: "PENDING",
  PAID: "PAID",
  VOID: "VOID",
};

export const PaymentMethod = {
  CHECK: "CHECK",
  ACH: "ACH",
  WIRE: "WIRE",
  CARD: "CARD",
  CASH: "CASH",
  OTHER: "OTHER",
};

export const PaymentMethods = [
  { id: PaymentMethod.CHECK, name: "Check" },
  { id: PaymentMethod.ACH, name: "ACH" },
  { id: PaymentMethod.WIRE, name: "Wire" },
  { id: PaymentMethod.CARD, name: "Card" },
  { id: PaymentMethod.CASH, name: "Cash" },
  { id: PaymentMethod.OTHER, name: "Other" },
];

export const InvoiceSubjectTokens = [
  { key: "{invoiceNumber}", label: "Invoice Number" },
  { key: "{poNumbers}", label: "Order Numbers" },
  { key: "{railCarNumbers}", label: "Car/Trl Numbers" },
  { key: "{pickupNumbers}", label: "Pickup Numbers" },
  { key: "{reloadYard.name}", label: "Yard Name" },
];

export const InvoiceDefaultSubject = [
  { type: "text", value: "Invoice #:" },
  { type: "token", value: "{invoiceNumber}" },
  { type: "text", value: ", Order #:" },
  { type: "token", value: "{poNumbers}" },
  { type: "text", value: "from" },
  { type: "token", value: "{reloadYard.name}" },
];

export const InvoiceStatuses = [
  { id: InvoiceStatus.NEW, name: "Draft" },
  { id: InvoiceStatus.PENDING, name: "Pending" },
  { id: InvoiceStatus.OVERDUE, name: "Overdue" },
  { id: InvoiceStatus.PAID, name: "Paid/Completed" },
  { id: InvoiceStatus.VOID, name: "Voided" },
];

export const LocationLoadType = {
  BOX: "box",
  CONTAINER: "container",
  OTHER: "other",
  PALLET: "pallet",
  SUPERSACK: "superSack",
  DRY_BULK: "dryBulk",
  LIQUID_BULK: "liquidBulk",
};

export const LocationLoadTypeOptions = [
  {
    id: LocationLoadType.BOX,
    name: "Box",
  },
  {
    id: LocationLoadType.PALLET,
    name: "Pallet",
  },
  {
    id: LocationLoadType.SUPERSACK,
    name: "SuperSack",
  },
  {
    id: LocationLoadType.CONTAINER,
    name: "Container",
  },
  {
    id: LocationLoadType.DRY_BULK,
    name: "Dry Bulk",
  },
  {
    id: LocationLoadType.LIQUID_BULK,
    name: "Liquid Bulk",
  },
  {
    id: LocationLoadType.OTHER,
    name: "Other",
  },
];

export const LocationType = {
  UNSTRUCTURED: "UNSTRUCTURED",
  STRUCTURED: "STRUCTURED",
  BULK: "BULK",
  BULK_MOBILE: "BULK_MOBILE",
};

export const LocationTypeOptions = [
  { id: LocationType.UNSTRUCTURED, name: "Unstructured" },
  { id: LocationType.STRUCTURED, name: "Structured" },
];

export const LogStatus = {
  NEW: "NEW",
  CLEARED: "CLEARED",
};

export const LogStatuses = [
  { id: "NEW", name: "NEW" },
  { id: "CLEARED", name: "CLEARED" },
];

export const LotType = {
  CARLOT: "CARLOT",
  PERPETUAL: "PERPETUAL",
};

export const LotTypes = [
  { id: "CARLOT", name: "Car Lot (Spec ID)" },
  { id: "PERPETUAL", name: "Perpetual (FIFO)" },
];

export const LotTypeNames = {
  CARLOT: "Car Lot (Spec ID)",
  PERPETUAL: "Perpetual (FIFO)",
};

export const CarlotLotNumberTokens = [
  { key: "{@last3}", label: "Last 3 of" },
  { key: "{@last4}", label: "Last 4 of" },
  { key: "{@last5}", label: "Last 5 of" },
  { key: "{@last6}", label: "Last 6 of" },
  { key: "{poNumber}", label: "PO Number" },
  { key: "{railCarNumber}", label: "Car/Trl Number" },
  { key: "{containerNumber}", label: "Container Number" },
];

export const DefaultCarlotLotNumber = [
  { type: "token", value: "{@last3}" },
  { type: "token", value: "{poNumber}" },
];

export const FifoLotNumberTokens = [
  { key: "{@DD}", label: "Day - DD" },
  { key: "{@MM}", label: "Month - MM" },
  { key: "{@QQ}", label: "Quarter - QQ" },
  { key: "{@YY}", label: "Year - YY" },
  { key: "{@YYYY}", label: "Year - YYYY" },
];

export const DefaultFifoLotNumber = [
  { type: "token", value: "{@DD}" },
  { type: "token", value: "{@MM}" },
];

export const NewCustomerStatus = {
  NEW: 10,
  PENDING_APPROVAL: 20,
  APPROVED: 30,
  REJECTED: 40,
};

export const NewCustomerStatusOptions = [
  { id: 10, name: "New" },
  { id: 20, name: "Pending Approval" },
  { id: 30, name: "Resolved Approved" },
  { id: 40, name: "Resolved Rejected" },
];

export const NoteType = {
  GENERIC: "GENERIC",
  SHIPMENT: "SHIPMENT",
  INVENTORY: "INVENTORY",
  AUDIT: "AUDIT",
};

export const OutboundAdviceInputOptions = [
  { id: "scheduledDateTime", name: "Schedule Appointment *" },
  { id: "poNumber", name: "PO Number *" },
  { id: "pickupNumber", name: "Pickup Number *" },
  { id: "carrierType", name: "Carrier Type *" },
  { id: "carrier", name: "Carrier Name *" },
  { id: "railCarNumber", name: "Car / Trl Number &" },
  { id: "mustTarp", name: "Must Tarp *" },
  { id: "shipTo", name: "Consignee Address *" },
  { id: "outboundCustomFields", name: "Custom Fields" },
  { id: "attachments", name: "Attach Files" },
  { id: "bolFile", name: "Attach BOL" },
  // { id: "shipmentLineItems", name: 'Picklist' },
];

export const OutboundStatus = {
  NEW: "NEW",
  ADVICE_ALL: "ADVICE_",
  ADVICE_PENDING: "ADVICE_PENDING",
  ADVICE_REJECTED: "ADVICE_REJECTED",
  PENDING: "PENDING",
  ARRIVED: "ARRIVED", // driver at the gate (arrivalDateTime)
  PLACED: "PLACED", // load placed / spotted (placementDateTime)
  LOADED: "LOADED",
  RELEASED: "RELEASED",
};

export const OutboundState = {
  COMPLETED: "COMPLETED",
  REJECTED: "REJECTED",
};

export const OutboundStatusLabels = {
  NEW: "New, Unsaved",
  PENDING: "Pending",
  ARRIVED: "Arrived",
  PLACED: "Placed",
  LOADED: "Loaded",
  RELEASED: "Shipped, Released",
};

export const OutboundSubjectTokens = [
  { key: "{poNumber}", label: "Order Number" },
  { key: "{consigneePoNumber}", label: "Consignee PO Number" },
  { key: "{pickupNumber}", label: "Pickup Number" },
  { key: "{railCarNumber}", label: "Car/Trl Number" },
  { key: "{reloadYard.name}", label: "Yard Name" },
  { key: "{shipTo.name}", label: "Consignee Name" },
];

export const POSDefaultSubject = [
  { type: "text", value: "Order #:" },
  { type: "token", value: "{poNumber}" },
  { type: "text", value: "shipped from" },
  { type: "token", value: "{reloadYard.name}" },
];

export const ResourceType = {
  ACCOUNT: "Account",
  CHARGE_RULE: "ChargeRule",
  INBOUND: "InboundShipment",
  INVENTORY: "Inventory",
  INVOICE: "Invoice",
  OUTBOUND: "OutboundShipment",
  PRODUCT: "Product",
  RELOADYARD: "ReloadYard",
  SERVICE: "Service",
  TASK: "Task",
};

export const PaymentTermType = {
  DUE_DAYS: "DUE_DAYS",
  STANDARD_DUE_DATE: "STANDARD_DUE_DATE",
};

export const PaymentTermsCodes = {
  COD: "COD",
};

export const DefaultPaymentTerms = [
  {
    code: "COD",
    name: "Due on receipt",
    type: PaymentTermType.DUE_DAYS,
    dueDays: 0,
  },
  {
    code: "NET_15",
    name: "Net 15",
    type: PaymentTermType.DUE_DAYS,
    dueDays: 15,
  },
  {
    code: "NET_30",
    name: "Net 30",
    type: PaymentTermType.DUE_DAYS,
    dueDays: 30,
  },
  {
    code: "NET_60",
    name: "Net 60",
    type: PaymentTermType.DUE_DAYS,
    dueDays: 60,
  },
];

export const PhotoStatus = {
  DONE: "DONE",
  UPLOADING: "UPLOADING",
  ERROR: "ERROR",
};

export const PhotoSubStatus = {
  UPLOADED: "uploaded",
  RETRYING: "retrying",
  PAUSED: "paused",
  ERROR: "error",
};
export const StatusMessages = {
  STARTING: "Starting upload...",
  UPLOADING: (percent) => `Uploading... ${percent}%`,
  SAVING: "Saving...",
  SAVING_ATTEMPT: (n, max) => `Saving... (attempt ${n}/${max})`,
  RETRYING: (n, max) => `Retrying... (attempt ${n}/${max})`,
  COMPLETE: "Upload complete, saving...",
  PAUSED_OFFLINE: "Paused (offline)",
  WAITING_CONNECTION: "Waiting for connection...",
  RESUMING: "Resuming upload...",
  WAITING_SAVE: "Waiting to save...",
  ERROR_GENERIC: (msg) => `Error: ${msg}`,
  ERROR_MAX_ATTEMPTS: "Failed after max attempts",
};
// Retry & Queue Configuration
export const MAX_MUTATION_ATTEMPTS = 20;
export const MAX_QUEUE_RETRY_ATTEMPTS = 10;
export const MIN_QUEUE_RETRY_DELAY = 2000; // 2 seconds
export const MAX_QUEUE_RETRY_DELAY = 60000; // 1 minute
export const PHOTO_UPDATE_PARENT_DEBOUNCE_MS = 200;
export const PHOTO_TRANSFER_COPY = Object.freeze({
  PANEL_TITLE: "Uploads in progress",
  STATUS_PAUSED: "Paused",
  STATUS_RETRYING: "Retrying...",
  STATUS_PROCESSING: "Processing...",
  STATUS_UPLOADING: "Uploading...",
  STATUS_ERROR_UNKNOWN: "Unknown",
  OFFLINE_SAVED_INFO: "📦 Photo saved offline. Will upload when connected.",
  QUEUE_SAVE_ERROR: "Failed to queue upload",
  QUEUE_SAVE_ERROR_TOAST: "❌ Failed to save photo",
  DELETE_SUCCESS: "Photo deleted",
  DELETE_FAILURE: "Failed to delete photo",
  DELETE_CONFIRM_TITLE: "Delete Photo",
  DELETE_CONFIRM_MESSAGE: "Are you sure you want to delete this image?",
  OFFLINE_QUEUE_LABEL: "Offline Queue:",
  OFFLINE_QUEUE_UPLOAD_SUFFIX: "waiting to upload",
  OFFLINE_QUEUE_SAVE_SUFFIX: "waiting to save",
  OFFLINE_QUEUE_SEPARATOR: " • ",
  OFFLINE_QUEUE_OFFLINE_SUFFIX: " - will retry when online",
  MAX_PHOTOS_WARNING: (max) => `Max. ${max} photos allowed.`,
});
export const PHOTO_TRANSFER_COLORS = Object.freeze({
  OFFLINE_QUEUE_BG: "#e3f2fd",
  OFFLINE_QUEUE_BORDER: "#2196f3",
  OFFLINE_QUEUE_TEXT: "#1565c0",
});
export const PortalType = {
  CREW: "CREW",
  MANAGER: "MANAGER",
};

// Synthetic track ID for unspotted cars (virtual track)
export const UNSPOTTED_TRACK_ID = "UNSPOTTED_VIRTUAL";

// Minimum weight difference (lbs) to consider a railcar "loaded" vs "empty"
// Used in TrackListView Empty/Loaded column calculation
export const MIN_LOAD_WEIGHT_LBS = 100;

export const Priorities = [
  { id: 0, name: "Low" },
  { id: 1, name: "Medium" },
  { id: 2, name: "High" },
  { id: 3, name: "Critical" },
];

export const ReloadYardStatus = {
  TRIALING: "TRIALING",
  ACTIVE: "ACTIVE",
  CANCELLED: "CANCELLED",
  SUSPENDED: "SUSPENDED", // temp suspension
  TERMINATED: "TERMINATED", // app access denied
};

export const ReloadYardStatusChoices = [
  { id: ReloadYardStatus.ACTIVE, name: "Active" },
  { id: ReloadYardStatus.CANCELED, name: "Canceled" },
  { id: ReloadYardStatus.TRIALING, name: "Trialing" },
  { id: ReloadYardStatus.SUSPENDED, name: "Suspended - Disable +CREATE" },
  { id: ReloadYardStatus.TERMINATED, name: "Terminated - Disable Login" },
];

export const ReturnReason = {
  OVERWEIGHT: "OVERWEIGHT",
  WRONG_PRODUCT: "WRONG_PRODUCT",
  WRONG_QUANTITY: "WRONG_QUANTITY",
  CUSTOMER_REQUEST: "CUSTOMER_REQUEST",
  OTHER: "OTHER",
};

export const ReturnReasonChoices = [
  { id: ReturnReason.OVERWEIGHT, name: "Overweight" },
  { id: ReturnReason.WRONG_PRODUCT, name: "Wrong Product" },
  { id: ReturnReason.WRONG_QUANTITY, name: "Wrong Quantity" },
  { id: ReturnReason.CUSTOMER_REQUEST, name: "Customer Request" },
  { id: ReturnReason.OTHER, name: "Other" },
];

export const S3ObjectType = {
  SHIPMENT: "SHIPMENT",
};

export const ServiceType = {
  OUTSIDE_HANDLING: "Outside Handling",
  INSIDE_HANDLING: "Inside Handling",
  OUTSIDE_STORAGE: "Outside Storage",
  INSIDE_STORAGE: "Inside Storage",
  ACCESSORIAL_CHARGES: "Accessorial Charges",
};

export const ServiceStatus = {
  NEW: "NEW",
  AVAILABLE: "AVAILABLE",
  UN_AVAILABLE: "UN_AVAILABLE",
};

export const ServiceStatuses = [
  { id: "AVAILABLE", name: "Available" },
  { id: "UN_AVAILABLE", name: "Suspended" },
];

export const ShipmentLineItemStatus = {
  NEW: "NEW",
  PENDING: "PENDING",
  LOADED: "LOADED",
  REJECTED: "REJECTED",
  VERIFIED: "VERIFIED",
  SHIPPED: "SHIPPED",
};

export const ShipmentLineItemStatuses = [
  { id: "NEW", name: "New, Unsaved" },
  { id: "PENDING", name: "Pending Shipment" },
  { id: "LOADED", name: "Loaded" },
  { id: "REJECTED", name: "Loaded, Rejected" },
  { id: "VERIFIED", name: "Loaded, Verified" },
  { id: "SHIPPED", name: "Shipped" },
];

export const TaskStatus = [
  { id: 10, name: "New" },
  { id: 20, name: "In Progress" },
  { id: 30, name: "Completed" },
  { id: 40, name: "Resolved Approved" },
  { id: 50, name: "Resolved Rejected" },
];

export const TaskType = {
  GENERIC: "GENERIC",
  AUDIT: "AUDIT",
  ACCEPT_SHIPMENT: "ACCEPT_SHIPMENT",
  PROCESS_OUTBOUND_SHIPMENT: "PROCESS_OUTBOUND_SHIPMENT",
  CAPACITY_UTILIZATION: "CAPACITY_UTILIZATION",
};

export const TaskTypes = [
  {
    id: TaskType.GENERIC,
    name: "Generic",
    description: "Generic Task",
    duration: "P1D",
  },
  // {
  // 	id: TaskType.AUDIT,
  // 	name: "Inventory Audit",
  // 	description: "Start a new audit from location %s",
  //     duration: "P2D"
  // },
  {
    id: TaskType.ACCEPT_SHIPMENT,
    name: "Inbound Shipment",
    description: "Accept shipment from %s, rail car number %s",
    duration: "P1D",
  },
  {
    id: TaskType.PROCESS_OUTBOUND_SHIPMENT,
    name: "Outbound Shipment",
    description: "Load outbound shipment.",
    duration: "P3D",
  },
  {
    id: TaskType.CAPACITY_UTILIZATION,
    name: "Capacity Utilization",
    description: "Update Capacity Utilization.",
    duration: "P1D",
  },
];

export const TransferType = {
  INTERNAL: "INTERNAL",
  EXTERNAL: "EXTERNAL",
};

export const TransferOptions = [
  { id: TransferType.INTERNAL, name: "Internal" },
  { id: TransferType.EXTERNAL, name: "External" },
];

export const TrueOrFalse = [
  { id: true, name: "Yes" },
  { id: false, name: "No" },
];

// update CatalogHeaderMap
export const Unit = {
  UNIT: "UNIT",
  PCS: "PCS",
  CAR: "CAR",
  TL: "TL",
  MBF: "MBF",
  LF: "LF",
  SF: "SF",
  MSF: "MSF",
  SQM: "SQM",
  GAL: "GAL",
  L: "L",
  LBS: "LBS",
  TN: "TN",
  CWT: "CWT",
  KG: "KG",
  MT: "MT",
  FT: "FT",
  M: "M",
};

// update CatalogHeaderMap
export const UnitToColumn = {
  [Unit.UNIT]: "unit",
  [Unit.PCS]: "pcs",
  [Unit.CAR]: "car",
  [Unit.TL]: "tl",
  [Unit.MBF]: "mbf",
  [Unit.LF]: "lf",
  [Unit.SF]: "sf",
  [Unit.MSF]: "msf",
  [Unit.SQM]: "sqm",
  [Unit.GAL]: "gal",
  [Unit.L]: "l",
  [Unit.LBS]: "lbs",
  [Unit.TN]: "tn",
  [Unit.CWT]: "cwt",
  [Unit.KG]: "kg",
  [Unit.MT]: "mt",
  [Unit.FT]: "ft",
  [Unit.M]: "m",
};

// CatalogHeaderMap
export const UnitConversionColumns = [
  UnitToColumn.UNIT,
  UnitToColumn.PCS,
  UnitToColumn.MBF,
  UnitToColumn.LF,
  UnitToColumn.SF,
  UnitToColumn.MSF,
  UnitToColumn.SQM,
  UnitToColumn.GAL,
  UnitToColumn.L,
  UnitToColumn.LBS,
  UnitToColumn.TN,
  UnitToColumn.CWT,
  UnitToColumn.KG,
  UnitToColumn.MT,
  UnitToColumn.FT,
  UnitToColumn.M,
];

export const UnitMap = {
  UNIT: { name: "UNIT(s)", description: "Unit / Package" },
  PCS: { name: "PCs", description: "Piece / Item" },
  CAR: { name: "Car", description: "Rail Car" },
  TL: { name: "TL", description: "Truckload" },
  MBF: { name: "MBF", description: "1K Board Feet" },
  LF: { name: "LF", description: "Linear Feet" },
  SF: { name: "SF", description: "Square Feet" },
  MSF: { name: "MSF", description: "1K Square Feet" },
  SQM: { name: "SQM", description: "Meters Squared" },
  GAL: { name: "GAL", description: "Gallons" },
  L: { name: "L", description: "Liters" },
  LBS: { name: "LBS", description: "Pounds" },
  TN: { name: "TN", description: "US Ton = 2000Lbs" },
  CWT: { name: "CWT", description: "Hundredweight = 100Lbs" },
  KG: { name: "KG", description: "Kilograms" },
  MT: { name: "MT", description: "Metric Ton" },
  FT: { name: "FT", description: "Feet" },
  M: { name: "M", description: "Meters" },
};

export const UnitOptions = [
  {
    id: Unit.UNIT,
    column: UnitToColumn[Unit.UNIT],
    name: UnitMap[Unit.UNIT].name,
    description: UnitMap[Unit.UNIT].description,
  },
  {
    id: Unit.PCS,
    column: UnitToColumn[Unit.PCS],
    name: UnitMap[Unit.PCS].name,
    description: UnitMap[Unit.PCS].description,
  },
  {
    id: Unit.CAR,
    column: UnitToColumn[Unit.CAR],
    name: UnitMap[Unit.CAR].name,
    description: UnitMap[Unit.CAR].description,
  },
  {
    id: Unit.TL,
    column: UnitToColumn[Unit.TL],
    name: UnitMap[Unit.TL].name,
    description: UnitMap[Unit.TL].description,
  },
  {
    id: Unit.MBF,
    column: UnitToColumn[Unit.MBF],
    name: UnitMap[Unit.MBF].name,
    description: UnitMap[Unit.MBF].description,
  },
  {
    id: Unit.LF,
    column: UnitToColumn[Unit.LF],
    name: UnitMap[Unit.LF].name,
    description: UnitMap[Unit.LF].description,
  },
  {
    id: Unit.SF,
    column: UnitToColumn[Unit.SF],
    name: UnitMap[Unit.SF].name,
    description: UnitMap[Unit.SF].description,
  },
  {
    id: Unit.MSF,
    column: UnitToColumn[Unit.MSF],
    name: UnitMap[Unit.MSF].name,
    description: UnitMap[Unit.MSF].description,
  },
  {
    id: Unit.SQM,
    column: UnitToColumn[Unit.SQM],
    name: UnitMap[Unit.SQM].name,
    description: UnitMap[Unit.SQM].description,
  },
  {
    id: Unit.GAL,
    column: UnitToColumn[Unit.GAL],
    name: UnitMap[Unit.GAL].name,
    description: UnitMap[Unit.GAL].description,
  },
  {
    id: Unit.L,
    column: UnitToColumn[Unit.L],
    name: UnitMap[Unit.L].name,
    description: UnitMap[Unit.L].description,
  },
  {
    id: Unit.LBS,
    column: UnitToColumn[Unit.LBS],
    name: UnitMap[Unit.LBS].name,
    description: UnitMap[Unit.LBS].description,
  },
  {
    id: Unit.TN,
    column: UnitToColumn[Unit.TN],
    name: UnitMap[Unit.TN].name,
    description: UnitMap[Unit.TN].description,
  },
  {
    id: Unit.CWT,
    column: UnitToColumn[Unit.CWT],
    name: UnitMap[Unit.CWT].name,
    description: UnitMap[Unit.CWT].description,
  },
  {
    id: Unit.KG,
    column: UnitToColumn[Unit.KG],
    name: UnitMap[Unit.KG].name,
    description: UnitMap[Unit.KG].description,
  },
  {
    id: Unit.MT,
    column: UnitToColumn[Unit.MT],
    name: UnitMap[Unit.MT].name,
    description: UnitMap[Unit.MT].description,
  },
  {
    id: Unit.FT,
    column: UnitToColumn[Unit.FT],
    name: UnitMap[Unit.FT].name,
    description: UnitMap[Unit.FT].description,
  },
  {
    id: Unit.M,
    column: UnitToColumn[Unit.M],
    name: UnitMap[Unit.M].name,
    description: UnitMap[Unit.M].description,
  },
];

export const PickListUnitOptions = [
  {
    id: Unit.UNIT,
    column: UnitToColumn[Unit.UNIT],
    name: UnitMap[Unit.UNIT].name,
    description: UnitMap[Unit.UNIT].description,
  },
  {
    id: Unit.PCS,
    column: UnitToColumn[Unit.PCS],
    name: UnitMap[Unit.PCS].name,
    description: UnitMap[Unit.PCS].description,
  },
];

// update CatalogHeaderMap
export const InventoryField = {
  PCS: "pcs",
  HEIGHT: "pcsHeight",
  WIDTH: "pcsWidth",
  LENGTH: "pcsLength",
};

export const InventoryFieldOptions = [
  { id: InventoryField.PCS, name: "PCS", description: "Pieces / Unit" },
  { id: InventoryField.HEIGHT, name: "Piece Height" },
  { id: InventoryField.WIDTH, name: "Piece Width" },
  { id: InventoryField.LENGTH, name: "Piece Length" },
];

export const UnitWeightOptions = [
  {
    id: Unit.LBS,
    name: UnitMap[Unit.LBS].name,
    description: UnitMap[Unit.LBS].description,
  },
  {
    id: Unit.TN,
    name: UnitMap[Unit.TN].name,
    description: UnitMap[Unit.TN].description,
  },
  {
    id: Unit.CWT,
    name: UnitMap[Unit.CWT].name,
    description: UnitMap[Unit.CWT].description,
  },
  {
    id: Unit.KG,
    name: UnitMap[Unit.KG].name,
    description: UnitMap[Unit.KG].description,
  },
  {
    id: Unit.MT,
    name: UnitMap[Unit.MT].name,
    description: UnitMap[Unit.MT].description,
  },
];

export const UnitAreaOptions = [
  {
    id: Unit.SF,
    name: UnitMap[Unit.SF].name,
    description: UnitMap[Unit.SF].description,
  },
  {
    id: Unit.MSF,
    name: UnitMap[Unit.MSF].name,
    description: UnitMap[Unit.MSF].description,
  },
  {
    id: Unit.SQM,
    name: UnitMap[Unit.SQM].name,
    description: UnitMap[Unit.SQM].description,
  },
];

export const UnitConversion = {
  [Unit.SF]: { SF: 1, SQM: 0.092903 },
  [Unit.MSF]: { MSF: 1, SF: 1000, SQM: 92.903 },
  [Unit.SQM]: { SF: 10.7639, MSF: 0.00107639, SQM: 1 },
  [Unit.GAL]: { GAL: 1, L: 3.78541 },
  [Unit.L]: { GAL: 0.264172, L: 1 },
  [Unit.LBS]: { LBS: 1, KG: 0.453592, MT: 0.000453592, TN: 0.0005, CWT: 0.01 },
  [Unit.TN]: { LBS: 2000, KG: 907.185, MT: 0.907185, TN: 1, CWT: 20 },
  [Unit.CWT]: { LBS: 100, KG: 45.3592, MT: 0.0453592, TN: 0.05, CWT: 1 },
  [Unit.KG]: { LBS: 2.20462, KG: 1, MT: 0.001, TN: 0.00110231, CWT: 0.0220462 },
  [Unit.MT]: { LBS: 2204.62, KG: 1000, MT: 1, TN: 1.10231, CWT: 22.0462 },
  [Unit.FT]: { FT: 1, M: 0.3048 },
  [Unit.M]: { FT: 3.28084, M: 1 },
};

export const CatalogHeaderMap = {
  "Product Code": "productCode",
  Name: "name",
  "Load Type": "reloadYardCommodityId",
  "Commodity Category": "category",
  "Units Of Measure": "defaultUOM",
  // "Default Weight UOM": "defaultWeightUOM",
  [Unit.UNIT]: UnitToColumn.UNIT,
  [Unit.PCS]: UnitToColumn.PCS,
  [Unit.MBF]: UnitToColumn.MBF,
  [Unit.LF]: UnitToColumn.LF,
  [Unit.SF]: UnitToColumn.SF,
  [Unit.MSF]: UnitToColumn.MSF,
  [Unit.SQM]: UnitToColumn.SQM,
  [Unit.GAL]: UnitToColumn.GAL,
  [Unit.L]: UnitToColumn.L,
  [Unit.LBS]: UnitToColumn.LBS,
  [Unit.TN]: UnitToColumn.TN,
  [Unit.CWT]: UnitToColumn.CWT,
  [Unit.KG]: UnitToColumn.KG,
  [Unit.MT]: UnitToColumn.MT,
  [Unit.FT]: UnitToColumn.FT,
  [Unit.M]: UnitToColumn.M,
  "Low Inventory Alert": "lowInventoryThreshold",
  "Piece Height": "pcsHeight",
  "Piece Width": "pcsWidth",
  "Piece Length": "pcsLength",
  Height: "height",
  Width: "width",
  Length: "length",
};

export const ChargeRuleHeaderMap = {
  Event: "event",
  "Service Name": "serviceName",
  "Billing UOM": "billingUOM",
  "Carrier Type": "carrierType",
  "Load Type": "reloadYardCommodityId",
  "Area ID": "areaId",
  "Zone ID": "zoneId",
  "Min Charge": "minCharge",
  "Max Charge": "maxCharge",
  "Storage Frequency": "frequency",
  "Fee Accrual": "feeAccrual",
  "Graduated Rates": "graduatedRates",
  "Free Days Policy": "freeDaysPolicy",
  "Free Days": "freeDays",
  "Free Railcars": "freeCars",
  Execution: "execution",
};

// Create rename mapping dynamically
export const ServiceHeaderMap = Object.fromEntries([
  ["Service Name", "name"],
  ["Description", "description"],
  ["Status", "status"],
  ["Tax Code", "taxCode"],
  ["Tax Rate %", "taxRate"],
  ...UnitOptions.map((unit) => [`${getUnitName(unit.id)}`, unit.column]),
]);

export const Urgency = {
  LOW: 1,
  HIGH: 2,
};

export const UrgencyOptions = [
  { id: Urgency.LOW, name: "LOW" },
  { id: Urgency.HIGH, name: "HIGH" },
];

export const UserStatus = {
  NEW: "NEW",
  PENDING_REG: "PENDING_REG",
  APPROVED: "APPROVED",
  // Drivers enrolled at a gate (driverApi enroll.js) are written ACTIVE, and
  // lifting a suspension restores that value. It means the same thing as
  // APPROVED — the driver has no portal login to approve, so the registration
  // states never applied to them. Without it here every enrolled driver
  // rendered as the grey "New" fallback with a blank status field.
  ACTIVE: "ACTIVE",
  SUSPENDED: "SUSPENDED",
};

export const UserStatuses = [
  { id: UserStatus.NEW, name: "New, Unsaved" },
  { id: UserStatus.PENDING_REG, name: "Pending Registration" },
  { id: UserStatus.APPROVED, name: "Active" },
  { id: UserStatus.ACTIVE, name: "Active" },
  { id: UserStatus.SUSPENDED, name: "Suspended" },
];

export const UserType = {
  ADMIN: "ADMIN",
  CREW: "CREW",
  SUPERVISOR: "SUPERVISOR",
  MANAGER: "MANAGER",
  CUSTOMER: "CUSTOMER",
  CARRIER_DISPATCH: "CARRIER_DISPATCH",
  CARRIER_DRIVER: "CARRIER_DRIVER",
};

export const UserTypeOptions = [
  { id: UserType.CREW, name: "Crew", description: "Operator App access only" },
  {
    id: UserType.SUPERVISOR,
    name: "Supervisor",
    description: "Manager Portal & Operator App access.",
  },
  {
    id: UserType.MANAGER,
    name: "Manager",
    description: "Full access to Manager Portal, Subscriptions & Operator App.",
  },
];

export const UserFileVisibility = {
  [UserType.CREW]: 101,
  [UserType.SUPERVISOR]: 201,
  [UserType.MANAGER]: 201,
};

export const CarrierUserTypeChoices = [
  {
    id: UserType.CARRIER_DISPATCH,
    name: "Dispatch",
    description: "Dispatch Portal & Driver App access.",
  },
  {
    id: UserType.CARRIER_DRIVER,
    name: "Driver",
    description: "Driver App access only.",
  },
];

export const UserAclOptions = [
  {
    id: AclType.ACCOUNTS,
    name: "Account Management",
    roles: {
      [UserType.SUPERVISOR]: true,
    },
  },
  {
    id: AclType.INVOICES,
    name: "Invoicing",
    roles: {
      [UserType.SUPERVISOR]: true,
    },
  },
  {
    id: AclType.MY_YARD,
    name: "My Yard Setup",
    roles: {
      [UserType.SUPERVISOR]: true,
    },
  },
  {
    id: AclType.ASSIGN_LOCATION,
    name: "Assign Inventory Locations",
    roles: {
      [UserType.SUPERVISOR]: true,
      [UserType.CREW]: true,
    },
  },
  {
    id: AclType.OUTBOUND_VERIFY,
    name: "Outbound Verification",
    roles: {
      [UserType.SUPERVISOR]: true,
      [UserType.CREW]: true,
    },
  },
  {
    id: AclType.OUTBOUND_SIGN,
    name: "Collect e-signature",
    roles: {
      [UserType.SUPERVISOR]: true,
      [UserType.CREW]: true,
    },
  },
  {
    id: AclType.INBOUND_ADVICE,
    name: "Create Inbound Advice",
    roles: {
      [UserType.CUSTOMER]: true,
    },
  },
  {
    id: AclType.OUTBOUND_ADVICE,
    name: "Create Outbound Advice",
    roles: {
      [UserType.CUSTOMER]: true,
    },
  },
  {
    id: AclType.INVOICES_VIEW,
    name: "View Invoices",
    roles: {
      [UserType.CUSTOMER]: true,
    },
  },
  {
    id: AclType.GATE_MANAGEMENT,
    name: "Gate Management",
    roles: {
      [UserType.SUPERVISOR]: true,
      [UserType.CREW]: true,
    },
  },
  {
    id: AclType.SIT,
    name: "SIT Cars",
    roles: {
      [UserType.CUSTOMER]: true,
    },
  },
  {
    id: AclType.TRACK_MANAGEMENT,
    name: "Track Management",
    roles: {
      [UserType.SUPERVISOR]: true,
      [UserType.CREW]: true,
      [UserType.CUSTOMER]: true,
    },
  },
  {
    id: AclType.USERS,
    name: "User Management",
    roles: {
      [UserType.SUPERVISOR]: true,
      [UserType.CUSTOMER]: true,
      [UserType.CARRIER_DISPATCH]: true,
    },
  },
  {
    id: AclType.CLAIM_LOAD,
    name: "Claim Loads",
    roles: {
      [UserType.CARRIER_DISPATCH]: true,
    },
  },
];

export const WorkflowType = {
  ACCEPT_STORE: "ACCEPT_STORE",
  BULK: "BULK",
};

export const Workflow = {
  INBOUND: "INBOUND",
  OUTBOUND: "OUTBOUND",
};

export const WorkflowChoices = [
  { id: "INBOUND", name: "Inbound" },
  { id: "OUTBOUND", name: "Outbound" },
];

export const workdays = [
  {
    id: "0",
    name: "Sunday",
    startDayTime: "8:00am",
    endDayTime: "5:00pm",
    selected: false,
  },
  {
    id: "1",
    name: "Monday",
    startDayTime: "8:00am",
    endDayTime: "5:00pm",
    selected: false,
  },
  {
    id: "2",
    name: "Tuesday",
    startDayTime: "8:00am",
    endDayTime: "5:00pm",
    selected: false,
  },
  {
    id: "3",
    name: "Wednesday",
    startDayTime: "8:00am",
    endDayTime: "5:00pm",
    selected: false,
  },
  {
    id: "4",
    name: "Thursday",
    startDayTime: "8:00am",
    endDayTime: "5:00pm",
    selected: false,
  },
  {
    id: "5",
    name: "Friday",
    startDayTime: "8:00am",
    endDayTime: "5:00pm",
    selected: false,
  },
  {
    id: "6",
    name: "Saturday",
    startDayTime: "8:00am",
    endDayTime: "5:00pm",
    selected: false,
  },
];

export const usHolidays = {
  "New Year's Day": "0,1",
  "Martin Luther King, Jr. Day": "0,2,1",
  "President's Day": "1,2,1",
  "Memorial Day": "4,-1,1",
  Juneteenth: "5,19",
  "Independence Day": "6,4",
  "Labor Day": "8,0,1",
  "Columbus Day": "9,1,1",
  "Veterans Day": "10,1",
  "Thanksgiving Day": "10,3,4",
  "Day after Thanksgiving": "10,3,5",
  Christmas: "11,25",
};

export const TimeZoneOptions = [
  { id: "America/New_York", name: "Eastern Time" },
  { id: "America/Chicago", name: "Central Time" },
  { id: "America/Denver", name: "Mountain Time" },
  { id: "America/Los_Angeles", name: "Pacific Time" },
];

export const EventType = {
  RESERVED: "RESERVED",
  ACCEPTED: "ACCEPTED",
  REJECTED: "REJECTED",
  CANCELLED: "CANCELLED",
};

export const HelpTopicOptions = [
  { id: "inbound", name: "Inbound Shipment" },
  { id: "outbound", name: "Outbound Shipment" },
  { id: "account", name: "Account" },
  { id: "inventory", name: "Inventory" },
  { id: "invoice", name: "Invoice" },
  { id: "myYard", name: "My Yard" },
  { id: "trackManagement", name: "Track Management" },
  { id: "adminAnnouncements", name: "Admin Announcements", kbExclude: true },
  { id: "adminHelpPages", name: "Admin Help Pages", kbExclude: true },
  { id: "yardUtilization", name: "Yard Utilization" },
  { id: "reports", name: "Reports" },
];

export const HelpLiveOptions = [
  { id: true, name: "true" },
  { id: false, name: "false" },
];

export const SealStatus = {
  NEW: "new",
};

export const Orientations = {
  LANDSCAPE: "Landscape",
  PORTRAIT: "Portrait",
};

export const SubscriptionStatus = {
  ACTIVE: "active",
  CANCELED: "canceled",
  TRIALING: "trialing",
  UNPAID: "unpaid",
};

export const SubscriptionStatusChoices = [
  { id: SubscriptionStatus.ACTIVE, name: "Active" },
  { id: SubscriptionStatus.CANCELED, name: "Canceled" },
  { id: SubscriptionStatus.TRIALING, name: "Trialing" },
  { id: SubscriptionStatus.UNPAID, name: "Unpaid" },
];

export const AccountStatus = {
  NEW: "NEW",
  ACTIVE: "ACTIVE",
};

export const AccountState = {
  ACTIVE: "true",
  ARCHIVED: "false",
};

export const barcodeExceptions = {
  MISMATCH: "BARCODE MISMATCH",
  INELIGIBLE: "BARCODE INELIGIBLE",
  MISSING: "BARCODE MISSING",
};

export const barcodeExceptionsChoices = [
  {
    id: "mismatch",
    name: "Barcode Mismatch",
    value: barcodeExceptions.MISMATCH,
  },
  {
    id: "ineligible",
    name: "Barcode Damaged",
    value: barcodeExceptions.INELIGIBLE,
  },
  { id: "missing", name: "Barcode Missing", value: barcodeExceptions.MISSING },
];

export const BarcodesStatus = {
  NEW: "NEW",
  PLACED: "PLACED",
  LOADED: "LOADED",
  SHIPPED: "SHIPPED",
};

export const DefaultZones = [
  {
    id: "DEFAULT-Y",
    name: "Default",
    prefix: "",
    color: "#8bc34a",
    zoneType: "DEFAULT",
    areaId: "YARD",
  },
  {
    id: "DEFAULT-W",
    name: "Default",
    prefix: "",
    color: "#FFB74D",
    zoneType: "DEFAULT",
    areaId: "WAREHOUSE",
  },
  {
    id: "DEFAULT-T",
    name: "Default",
    prefix: "",
    color: "#4DD0E1",
    zoneType: "DEFAULT",
    areaId: "TRACK",
  },
];
